export enum FormatTimeUom {
    ms = 'ms',
    s = 's',
    m = 'm',
    h = 'h',
    d = 'd'
} // https://momentjs.com/docs/#/displaying/

export interface ThrottleMSValueProps {
    value: number
    formatTimeUom: FormatTimeUom
    baseUom?: FormatTimeUom.ms | FormatTimeUom
}

export interface ThrottleMSProps {
    current: ThrottleMSValueProps
    onChangeValue: (currentValue: number) => void
    onChangeUom: (currentUom: string) => void
}
